import { render, staticRenderFns } from "./social-media-navigation.vue?vue&type=template&id=4f76e9a8&"
import script from "./social-media-navigation.vue?vue&type=script&lang=js&"
export * from "./social-media-navigation.vue?vue&type=script&lang=js&"
import style0 from "./_social-media-navigation.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports